import { useMemo } from 'react';
import { buildShopHref, parseActiveSelection } from './topicNavRouting';
export function useTopicNavConfig(path, raw) {
    return useMemo(function () {
        var active = parseActiveSelection(path);
        var topics = {
            href: raw.topics.href,
            label: raw.topics.label,
            items: raw.topics.items.map(function (_a) {
                var slug = _a.slug, label = _a.label, icon = _a.icon;
                var isActive = slug === active.topic;
                return {
                    href: buildShopHref(isActive
                        ? { product: active.product }
                        : { topic: slug, product: active.product }),
                    label: label,
                    icon: icon,
                    active: isActive,
                };
            }),
        };
        var products = {
            href: raw.products.href,
            label: raw.products.label,
            items: raw.products.items.map(function (_a) {
                var slug = _a.slug, label = _a.label, icon = _a.icon;
                var isActive = slug === active.product;
                return {
                    href: buildShopHref(isActive
                        ? { topic: active.topic }
                        : { topic: active.topic, product: slug }),
                    label: label,
                    icon: icon,
                    active: isActive,
                };
            }),
        };
        return { topics: topics, products: products };
    }, [path, raw]);
}
